module.exports = __webpack_public_path__ + "img/icon-7.a4fba2de.png";